import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const updateProfileIntroduction = async (
  token: any,
  introduction: string
) => {
  try {
    const payload = {
      text: introduction,
    };

    await axios.post(`${API_BASE_URL}/UpdateProfileIntroduction`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return true;
  } catch (error) {
    console.error("Error deleting Professional Experience:", error);
    return false;
  }
};

export const saveCertification = async (token: any, certificationData: any) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/SaveCertification`,
      certificationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error saving Certification:", error);
    throw error;
  }
};
